// resources/js/src/components/community/stories/CreateStoryButton.tsx
import React, { useRef } from "react";
import { useAuthStore } from "../../../../../auth/auth.store";

interface Props {
  onFileSelect: (file: File) => void;
  disabled?: boolean;
}

const CreateStoryButton: React.FC<Props> = ({ onFileSelect, disabled = false }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const currentUser = useAuthStore((s) => s.currentUser);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) onFileSelect(file);
    e.target.value = "";
  };

  const avatarSrc =
    currentUser?.avatarUrl ||
    `https://ui-avatars.com/api/?name=${encodeURIComponent(
      currentUser?.name ?? "You"
    )}&background=10b981&color=fff&size=128&bold=true`;

  return (
    <>
      <button
        type="button"
        disabled={disabled}
        onClick={() => inputRef.current?.click()}
        className="flex flex-col items-center cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
        aria-label="Create story"
      >
        <div className="relative w-28 h-28 rounded-full p-1 border-2 border-dashed border-tealGreen dark:border-primary">
          <img
            src={avatarSrc}
            alt={currentUser?.name ?? "You"}
            className="w-full h-full rounded-full object-cover"
            onError={(e) => {
              (e.target as HTMLImageElement).src = `https://ui-avatars.com/api/?name=${encodeURIComponent(
                currentUser?.name ?? "You"
              )}&background=10b981&color=fff&size=128&bold=true`;
            }}
          />

          <span className="absolute -bottom-1 -right-1 w-8 h-8 rounded-full bg-tealGreen dark:bg-primary text-white flex items-center justify-center text-xl font-bold border-2 border-white dark:border-deepSlate">
            +
          </span>
        </div>

        <span className="text-xs mt-2 truncate w-24 text-center dark:text-muted">
          Create Story
        </span>
      </button>

      <input
        ref={inputRef}
        type="file"
        hidden
        accept="image/*,video/*"
        onChange={handleChange}
      />
    </>
  );
};

export default CreateStoryButton;